import styled from 'styled-components';
import { breakSmall } from '../themes/homedepotcom/breakpoints';

export default (imageWidth, imageInnerWidth) => styled.div`
  .config-product-image {
    width: ${imageWidth};
    height: 340px;
    @media only screen and (max-width: ${breakSmall}) {
      &.mobile {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
    img {
      width: ${imageWidth};
      height: 175px;
      @media only screen and (max-width: ${breakSmall}) {
        align-self: center;
        flex: 0 0 auto;
        object-fit: cover;
        width: 85vw;
        height: ${imageInnerWidth};
      }
    }
  }
`;
